import React from "react";
import { useSelector } from "react-redux";
import * as SubmissionStatus from "../models/SubmissionStatus";
import classes from './StatusBar.module.css'

const StatusBar = ({ currentStatus, submittedDate, assessmentDueDate }) => {

    const StatusEnum = [
        { name: SubmissionStatus.started, text: 'Started', color: "#73DED8" },
        { name: SubmissionStatus.submitted, text: 'Submitted', color: "#73DED8" },
        { name: SubmissionStatus.submitted, text: 'submittedLate', color: "#ED8068" },
        { name: SubmissionStatus.rejected, text: 'Rejected', color: "#FF9A03" },
        { name: SubmissionStatus.resubmitted, text: 'Resubmitted', color: "#FEF652" },
        { name: SubmissionStatus.completed, text: 'Scored', color: "#FEF652" },
    ]
    const texts = useSelector(state => state.translate.texts);


    return (
        <div className={classes.NewStatusBar}>
            {StatusEnum.map((s, index) => {
                const currentIndex = StatusEnum.findIndex(x => x.name == currentStatus);
                let currentIndex2 = currentIndex;
                if (currentIndex === -1 || (SubmissionStatus.started && currentIndex2 == 1 && assessmentDueDate && submittedDate > assessmentDueDate)) {
                    currentIndex2++;
                }
                return (<div key={s.text} className={classes.StatusStepContainer}>
                    {currentIndex2 == index ? <div className={classes.CurrentStep}>{texts[s.text]}</div> : <div></div>}
                    <div className={classes.StatusStep} style={{ borderColor: s.color, backgroundColor: currentIndex2 >= index ? s.color : 'transparent' }}></div>
                </div>)
            })}
        </div>
    )
}

export default StatusBar;